<template>
  <q-card square>
    <div class="title">{{ title }}</div>
    <vue-highcharts :options="highchartOption"></vue-highcharts>
  </q-card>
</template>

<script>
import moment from "moment";
import { Chart } from "highcharts-vue";
export default {
  components: {
    VueHighcharts: Chart,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    subtitle: {
      type: Number,
      required: false,
    },
    colors: {
      type: Array,
      required: false,
      default: () => ["#003f5c", "#ff6361", "#ffdd00"],
    },
  },
  data() {
    return {
      highchartOption: {
        chart: {
          height: 250,
          type: "column",
          style: {
            fontFamily: "Roboto",
          },
        },
        title: {
          text: this.subtitle ? `Depreciation ${this.subtitle}%` : "",
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          labels: {
            formatter: function() {
              return this.value.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              });
            },
          },
        },
        // tooltip: {
        //   split: true,
        //   pointFormat:
        //     '<span style="color:{series.color}">{series.name}</span>: <b>${point.y}</b><br/>',
        // },
        tooltip: {
          headerFormat:
            '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>$ {point.y:.1f}</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true,
        },
        colors: this.colors,
        credits: {
          enabled: false,
        },
        plotOptions: {
          // bar: {
          //   dataLabels: {
          //     enabled: true,
          //   },
          // },
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Projected Payoff",
            data: [],
          },
          // {
          //   name: "Projected Auction Value",
          //   data: [],
          // },
          {
            name: "Owner Depreciation",
            data: [],
          },
        ],
      },
    };
  },
  created() {
    this._categories();
  },
  methods: {
    _categories() {
      let chart_months = ["Now"];
      for (let index = 1; index < 25; index++) {
        const now = moment();
        const futureMonth = moment(now)
          .add(index, "M")
          .format("MMM Do YY");
        chart_months = [...chart_months, futureMonth];
      }
      this.highchartOption.xAxis.categories = chart_months;
    },
    analyisPusher(months) {
      var titles = [
        "projected_payoff",
        // "projected_auction",
        "owner_depreciation",
      ];
      for (let i = 0; i < titles.length; i++) {
        months.forEach((element) => {
          const j = titles[i];
          if ("projected_payoff" === j) {
            this.highchartOption.series[0].data.push(element.projected_payoff);
          }
          // else if ("projected_auction" === j) {
          //   this.highchartOption.series[1].data.push(element.projected_auction);
          // }
          else if ("owner_depreciation" === j) {
            this.highchartOption.series[1].data.push(
              element.owner_depreciation
            );
          }
        });
      }
    },
  },
  watch: {
    items: {
      deep: true,
      immediate: true,
      handler(n, o) {
        this.analyisPusher(n);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 25px;
  font-weight: bold;
  color: #000;
  padding: 10px 0px;
  text-align: center;
}
</style>
